import { useState } from "react";
import { FormButton } from "../buttons/form-button/FormButton";
import styles from "./SecretLoginForm.module.css";

type SecretLoginFormProps = {
  handleClick: (clientId: string, clientSecret: string) => void;
};

export const SecretLoginForm: React.FC<SecretLoginFormProps> = ({
  handleClick,
}) => {
  const [clientId, setClientId] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [clientIdLabel, setClientIdLabel] = useState(false);
  const [clientSecretLabel, setClientSecretLabel] = useState(false);
  const [clearedClientId, setClearedClientId] = useState(false);
  const [clearedClientSecret, setClearedClientSecret] = useState(false);
  const [clientIdInputActive, setClientIdInputActive] = useState(false);
  const [clientSecretInputActive, setClientSecretInputActive] = useState(false);

  return (
    <form className={styles.form}>
      <div className={styles.divInput}>
        <p className={clientIdLabel ? styles.label : styles.labelHidden}>
          ClientId
        </p>
        <input
          className={styles.input}
          id="clientId"
          type="clientId"
          value={clearedClientId ? "" : clientId}
          onChange={(e) => {
            setClearedClientId(false);
            setClientId(e.target.value);
            setClientIdLabel(true);
            setClientIdInputActive(true);
          }}
          placeholder="ClientId"
        />
        <svg
          role="button"
          onClick={(e) => {
            setClearedClientId(true);
            setClientIdLabel(false);
            setClientIdInputActive(false);
          }}
          className={
            clientIdInputActive ? styles.crossSvg : styles.crossSvgHidden
          }
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24.0002 30.6668C20.3183 30.6668 17.3335 27.682 17.3335 24.0002C17.3335 20.3183 20.3183 17.3335 24.0002 17.3335C27.682 17.3335 30.6668 20.3183 30.6668 24.0002C30.6668 27.682 27.682 30.6668 24.0002 30.6668ZM24.0002 23.0574L22.5859 21.6431C22.3256 21.3828 21.9035 21.3828 21.6431 21.6431C21.3828 21.9035 21.3828 22.3256 21.6431 22.5859L23.0574 24.0002L21.6431 25.4144C21.3828 25.6747 21.3828 26.0968 21.6431 26.3572C21.9035 26.6175 22.3256 26.6175 22.5859 26.3572L24.0002 24.943L25.4144 26.3572C25.6747 26.6175 26.0968 26.6175 26.3572 26.3572C26.6175 26.0968 26.6175 25.6747 26.3572 25.4144L24.943 24.0002L26.3572 22.5859C26.6175 22.3256 26.6175 21.9035 26.3572 21.6431C26.0968 21.3828 25.6747 21.3828 25.4144 21.6431L24.0002 23.0574Z"
            fill="#848790"
          />
        </svg>
      </div>
      <div className={styles.divInput}>
        <input
          id="clientSecret"
          className={styles.input}
          type="clientSecret"
          value={clearedClientSecret ? "" : clientSecret}
          onChange={(e) => {
            setClearedClientSecret(false);
            setClientSecret(e.target.value);
            setClientSecretLabel(true);
            setClientSecretInputActive(true);
          }}
          placeholder="ClientSecret"
        />
        <p className={clientSecretLabel ? styles.label : styles.labelHidden}>
          ClientSecret
        </p>
        <svg
          role="button"
          onClick={(e) => {
            setClearedClientSecret(true);
            setClientSecretLabel(false);
            setClientSecretInputActive(false);
          }}
          className={
            clientSecretInputActive ? styles.crossSvg : styles.crossSvgHidden
          }
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24.0002 30.6668C20.3183 30.6668 17.3335 27.682 17.3335 24.0002C17.3335 20.3183 20.3183 17.3335 24.0002 17.3335C27.682 17.3335 30.6668 20.3183 30.6668 24.0002C30.6668 27.682 27.682 30.6668 24.0002 30.6668ZM24.0002 23.0574L22.5859 21.6431C22.3256 21.3828 21.9035 21.3828 21.6431 21.6431C21.3828 21.9035 21.3828 22.3256 21.6431 22.5859L23.0574 24.0002L21.6431 25.4144C21.3828 25.6747 21.3828 26.0968 21.6431 26.3572C21.9035 26.6175 22.3256 26.6175 22.5859 26.3572L24.0002 24.943L25.4144 26.3572C25.6747 26.6175 26.0968 26.6175 26.3572 26.3572C26.6175 26.0968 26.6175 25.6747 26.3572 25.4144L24.943 24.0002L26.3572 22.5859C26.6175 22.3256 26.6175 21.9035 26.3572 21.6431C26.0968 21.3828 25.6747 21.3828 25.4144 21.6431L24.0002 23.0574Z"
            fill="#848790"
          />
        </svg>
      </div>
      <FormButton
        id="submit_form"
        className={styles.button}
        onClick={(e) => {
          handleClick(clientId, clientSecret);
          e.preventDefault();
        }}
      >
        Login
      </FormButton>
    </form>
  );
};
